import { Navigate } from 'react-router-dom';
import { useAuth, STORAGE_TOKEN_KEY } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const hasToken = !!localStorage.getItem(STORAGE_TOKEN_KEY);

  // Show loading state when:
  // 1. Auth context reports loading
  // 2. We have a token but no user yet (still loading) - give it more time
  if (loading || (hasToken && !user)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#699269]"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Only redirect if we have no token AND no user
  // If we have a token, give it more time to load (don't redirect immediately)
  if (!user && !hasToken) {
    return <Navigate to="/login" replace />;
  }

  // If we have a token but no user after loading, something went wrong
  // But don't redirect immediately - let the auth context handle it
  if (hasToken && !user && !loading) {
    // Wait a bit more - might be a race condition
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#699269]"></div>
          <p className="mt-4 text-gray-600">Loading profile...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

